import { Grid, ListItemButton } from '@mui/material';
import Typography from '@mui/material/Typography';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import React from 'react';
import { Link } from 'react-router-dom';
import { mb } from '../../common/theme/mbTokens';
import { SidebarIcon, SidebarIconName } from './sidebarIcons';

type MenuButtonProps = {
  name: string;
  icon?: SidebarIconName;
  isSubMenuItem?: boolean;
  itemIsActive?: boolean;
  isOpenParent?: boolean;
  hasChildren?: boolean;
  isExpanded?: boolean;
  onClick: () => void;
  /** Makes the row itself the link, so it is one focusable element. */
  navigate?: string;
  external?: boolean;
  target?: string;
  count?: number;
};

export const MenuButton = ({
  name,
  icon,
  isSubMenuItem,
  itemIsActive,
  isOpenParent,
  hasChildren,
  isExpanded,
  onClick,
  navigate,
  external,
  target,
  count,
}: MenuButtonProps) => {
  const linkProps = !navigate
    ? {}
    : external
    ? { component: 'a', href: navigate, target: '_blank', rel: 'noreferrer' }
    : { component: Link, to: navigate, target };
  return (
    <ListItemButton
      {...linkProps}
      selected={itemIsActive}
      onClick={onClick}
      aria-current={itemIsActive ? 'page' : undefined}
      aria-expanded={hasChildren ? isExpanded : undefined}
      sx={{
        minHeight: isSubMenuItem ? 38 : 42,
        gap: isSubMenuItem ? 1.25 : 1.5,
        paddingInline: 1.25,
        paddingBlock: 0,
        fontSize: isSubMenuItem ? 14 : 15,
        color: isOpenParent ? 'primary.main' : 'text.primary',
        fontWeight: isOpenParent ? 600 : 400,
        ...(isSubMenuItem && {
          '&.Mui-selected, &.Mui-selected:hover': {
            bgcolor: 'primary.light',
            color: 'primary.main',
            fontWeight: 600,
            '--mb-icon-wash': mb.iconWashActiveSecondary,
          },
        }),
      }}>
      {icon ? (
        <SidebarIcon name={icon} size={isSubMenuItem ? 18 : 22} />
      ) : (
        isSubMenuItem && <Grid component="span" aria-hidden sx={{ width: 18, flexShrink: 0 }} />
      )}
      <Typography
        component="span"
        sx={{ flex: 1, fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 1.3, whiteSpace: 'normal' }}>
        {name}
      </Typography>
      {count !== undefined && count > 0 && (
        <Typography
          component="span"
          sx={{
            minWidth: 22,
            paddingInline: 0.75,
            borderRadius: '4px',
            bgcolor: 'mb.surface',
            color: 'mb.danger',
            fontSize: 13,
            fontWeight: 700,
            lineHeight: '22px',
            textAlign: 'center',
          }}>
          {count}
        </Typography>
      )}
      {hasChildren && (isExpanded ? <ExpandLess sx={{ fontSize: 16 }} /> : <ExpandMore sx={{ fontSize: 16 }} />)}
    </ListItemButton>
  );
};
